// Shared imaging pipeline status resolution (Orders + Worklist + Imaging)

export const IMAGING_STATUS_STYLES = {
  NOT_UPLOADED: { label: "Not Uploaded", color: "#64748B", bg: "#F1F5F9" },
  AWAITING_REPORT: {
    label: "Awaiting Report",
    color: "#EA580C",
    bg: "#FFF7ED",
  },
  COMPLETED: { label: "Completed", color: "#10B981", bg: "#D1FAE5" },
  FAILED: { label: "Failed", color: "#EF4444", bg: "#FEF2F2" },
};

/**
 * Resolve imaging display status from study/order + image counts.
 * Flow: Not Uploaded → Awaiting Report → Completed
 * Failed = expected images but sync/upload did not succeed.
 */
export function resolveImagingStatus(study) {
  const instances =
    study.totalInstances || study.instanceCount || study.images || 0;
  const orderStatus = study.status || study.orderStatus || "";
  const hasImages = instances > 0 || study.hasImages;

  // PACS pipeline "done": RIS reported it OR a DycoVue remote report was issued.
  // Self-report completion is a separate RIS-side workflow and does not close the imaging pipeline.
  const reportDone =
    orderStatus === "REPORTED" ||
    study.dycovueReportStatus === "completed";

  const syncFailed =
    study.orthancStatus === "failed" || study.uploadStatus === "failed";

  if (reportDone) {
    return { key: "COMPLETED", subText: "Report finalized" };
  }

  if (syncFailed) {
    return { key: "FAILED", subText: "Sync failed — upload manually" };
  }

  if (!hasImages) {
    if (["ENDEXAM", "TOREPORT", "PRELIM", "QC"].includes(orderStatus)) {
      return { key: "FAILED", subText: "Images not synced" };
    }
    return { key: "NOT_UPLOADED", subText: "No images yet" };
  }

  return {
    key: "AWAITING_REPORT",
    subText: `${instances} image(s) — pending report`,
  };
}
